<template>

  <div>

    <v-simple-table v-if="restructuringData">
      <template v-slot:default>
        <thead>
        <tr>
          <th colspan="6" class="tableheader"><h3>Debt Restructuring</h3></th>
        </tr>
        <tr>
          <th class="text-left">
            Registration No.
          </th>
          <th class="text-left">
            Contact
          </th>
          <th class="text-left">
            Contact No.
          </th>
          <th class="text-left">
            Application Date
          </th>
          <th class="text-left">
            Status
          </th>
          <th class="text-left">
            Status Date
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in restructuringData.rows" :key="item.num">
          <td>{{ item.regNo }}</td>
          <td>{{ item.contactPerson }}</td>
          <td>{{ item.telNo }}</td>
          <td>{{ item.applicationDate }}</td>
          <td>{{ item.statusDesc }}</td>
          <td>{{ item.statusDate }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
        <tr>
          <th colspan="6" class="tableheader"><h3>Debt Restructuring</h3></th>
        </tr>
        <tr>
          <th class="text-left">
            Registration No.
          </th>
          <th class="text-left">
            Contact
          </th>
          <th class="text-left">
            Contact No.
          </th>
          <th class="text-left">
            Application Date
          </th>
          <th class="text-left">
            Status
          </th>
          <th class="text-left">
            Status Date
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="6" align="middle">
            -- None --
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>


  </div>
</template>

<script>
import ExperianService from "@/services/experian.service";

export default {
  name: "DebtRestructuringInfo",
  props: ['rsaId'],
  data() {
    return {
      restructuringData: null
    }
  },
  async created() {
    this.restructuringData = await ExperianService.getDebtRestructuring({
      rsaId: this.rsaId,
    })
  }
}
</script>

<style>
.tableheader {
  color: #FFFFFF !important;
  background: #03a9f4;
}
</style>

